/*
DO NOT MANUALLY TRANSLATE!
Follow the instructions in the README.md to conveniently update translations.
*/

export default {
  "CookieMessage.old.link": "Več informacij",
  "CookieMessage.old.text":
    "Za dobro delovanje naše spletne trgovine uporabljamo piškotke. Oglejte si naš pravilnik o piškotkih.",
  "CookieMessage.link": "Sprejemanje piškotkov",
  "CookieMessage.more_information": "Preberite več o piškotkih Kramp",
  "CookieMessage.return": "Pojdi nazaj",
  "CookieMessage.intro.body":
    "Piškotke so namestili podjetje Kramp in tretje osebe. Samoumevno je, da dobro skrbimo za vašo zasebnost. Če spodaj kliknete Sprejmi piškotke, se strinjate z uporabo teh piškotkov. S sprejetjem teh piškotkov zagotavljate pravilno delovanje našega spletnega mesta. Piškotki se uporabljajo za",
  "CookieMessage.intro.list.1": "Samodejno prijavo v Moj profil",
  "CookieMessage.intro.list.2":
    "Analizo vedenja obiskovalcev za izboljšanje spletnega mesta.",
  "CookieMessage.intro.list.3":
    "Ustvarjanje profilov strank, da vam lahko zagotavljamo prilagojene informacije in oglase.",
  "CookieMessage.intro.extra":
    'Če ne želite sprejeti vseh piškotkov, lahko to spremenite v svojih <a>nastavitve</a>. Za več informacij preberite našo <a href="{legalLink}">privacy and cookie statement</a>',
  "CookieMessage.intro.title": "Podjetje Kramp uporablja piškotke",
  "CookieMessage.settings.body":
    "Izbirate lahko med tremi nastavitvami piškotkov. Z izbiro standardne nastavitve vam bomo lahko zagotovili najboljšo izkušnjo s spletnim mestom.",
  "CookieMessage.settings.standard.title": "Standardno (najbolj priljubljeno):",
  "CookieMessage.settings.standard.body":
    "Piškotki, ki se uporabljajo za prijavo, naročanje, analizo, prilagojene informacije, družbene medije in piškotke tretjih oseb.",
  "CookieMessage.settings.restricted.title": "Omejeno:",
  "CookieMessage.settings.restricted.body":
    "Piškotki, ki se uporabljajo za prijavo v analizo naročanja in prilagojene informacije.",
  "CookieMessage.settings.highly_restricted.title": "Zelo omejeno:",
  "CookieMessage.settings.highly_restricted.body":
    "Dovolite le najmanjše število piškotkov. Uporablja se izključno za prijavo pri naročanju in omogočanje delovanja spletnega mesta v razumnem obsegu.",
  "CookieMessage.settings.options.title": "Mi pa počnemo naslednje:",
  "CookieMessage.settings.option.1":
    "Uporabljamo piškotke za zagotavljanje pravilnega delovanja tega spletnega mesta.",
  "CookieMessage.settings.option.2": "Raziskujemo vedenje uporabnikov",
  "CookieMessage.settings.option.3": "Spremljamo osebne statistične podatke",
  "CookieMessage.settings.option.4":
    "Prikazujemo informacije, ki bi vas lahko zanimale",
  "CookieMessage.settings.option.5": "Uporabljamo podatke za svoje oglase",
  "CookieMessage.settings.option.6": "Spremljamo anonimne statistične podatke",
  "CookieMessage.settings.option.7": "Delimo vaše osebne podatke",
  "CookieMessage.settings.title": "Nastavitve piškotkov",
};
